import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatRating } from "@/utils/movies";

interface MovieListItemProps {
  movie: Movie;
}

export default function MovieListItem({ movie }: MovieListItemProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:gap-4 md:p-4"
    >
      <div className="relative h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-44">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} 剧照`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-1.5 top-1.5 rounded bg-primary-500 px-1.5 py-0.5 font-label text-[10px] font-semibold text-background-50">
          {movie.quality}
        </span>
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
            {movie.title}
          </h3>
          <span className="inline-flex shrink-0 items-center gap-0.5 font-label text-sm font-bold text-accent-600">
            <i className="ri-star-fill text-xs" aria-hidden="true" />
            {formatRating(movie.rating)}
          </span>
        </div>
        <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span aria-hidden="true">·</span>
          <span>{movie.region}</span>
          <span aria-hidden="true">·</span>
          <span className="line-clamp-1">{movie.genres.join(" / ")}</span>
        </p>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-600">
          主演：{movie.actors.join("、")}
        </p>
        <p className="mt-auto hidden line-clamp-2 pt-1 text-xs leading-relaxed text-foreground-500 sm:block">
          {movie.synopsis}
        </p>
      </div>
    </Link>
  );
}